import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Loader, EmptyState } from "@/components/shared";
import { Button } from "@/components/ui/button";
import * as Icons from "lucide-react";

const ICONS = { badge: "Medal", quest: "Target", attendance: "CalendarCheck", points: "Star", announcement: "Megaphone", story: "Mic" };

export default function Notifications() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ["notifications"], queryFn: async () => (await api.get("/notifications")).data });
  if (isLoading) return <Loader />;

  const readAll = async () => { await api.post("/notifications/read-all"); qc.invalidateQueries({ queryKey: ["notifications"] }); };

  return (
    <div className="space-y-6 mx-auto max-w-2xl" data-testid="notifications-page">
      <div className="flex items-center justify-between">
        <h1 className="font-head text-4xl text-csh-blue">Notifications 🔔</h1>
        <Button onClick={readAll} variant="ghost" className="rounded-full text-csh-purple font-bold">Mark all read</Button>
      </div>
      {(!data || data.length === 0) ? <EmptyState icon="Bell" title="All caught up!" text="You have no notifications right now." /> : (
        <div className="space-y-2">
          {data.map((n) => { const I = Icons[ICONS[n.type] || "Bell"]; return (
            <div key={n.id} className={`flex items-start gap-3 rounded-2xl px-4 py-3 shadow-sm border ${n.read ? "bg-white border-black/5" : "bg-csh-orange/5 border-csh-orange/30"}`}>
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl gradient-purple"><I size={18} className="text-white" /></div>
              <div className="flex-1">
                <div className="font-bold text-csh-blue">{n.title}</div>
                <div className="text-sm text-muted-foreground">{n.message}</div>
                <div className="text-[10px] text-muted-foreground mt-0.5">{n.created_at?.slice(0, 16).replace("T", " ")}</div>
              </div>
              {!n.read && <span className="mt-1 h-2 w-2 rounded-full bg-csh-orange" />}
            </div>
          ); })}
        </div>
      )}
    </div>
  );
}
